module.exports = "https://web-assets-production.autolist.com/_next/static/images/wagon-f8c393d4e81053429095f7ef81838502.jpg";